import { ListView, Item, Layout, Size } from "@albelli/image-list-view"
import React, { useEffect, useState, useRef } from "react"
import { useElementSize } from "./helpers"
import { ContainerItemView } from "./ContainerItemView"

interface ListViewProps {
  items: Item[]
  layout: Layout
  className?: any
  style?: any
  viewRef?: (renderedView: HTMLElement) => void
  children: (item: Item) => React.ReactElement<any>
  onScroll?: (event: Event) => void
}

/**
 * Implements ListView to be handled with resizable layout
 */
export const ContainerListView: React.FunctionComponent<ListViewProps> = ({ layout, items, viewRef, children, className, style, onScroll }) => {
  const ref: React.RefObject<HTMLDivElement> = useRef(null)
  const size: Size | undefined = useElementSize(ref, 200)

  const [view, setView] = useState<ListView<Item> | null>(null)

  useEffect(() => {
    if (size && size.width > 0 && size.height > 0 && !view) {
      // create renderer for list view
      const renderer = (item: Item, container: HTMLElement) => {
        return new ContainerItemView(item, container, children)
      }
      // creates view which the list will be rendered to
      const listView = new ListView(items, layout, renderer)
      const rendered = listView.render(size)
      if (ref.current) {
        ref.current.appendChild(rendered)
      }
      // return rendered list view
      // for now used to add extra event listeners to DOM element
      viewRef && viewRef(rendered)
      // TODO: root has to be public from list view library
      // or there should be option to add event listeners
      onScroll && rendered.addEventListener("scroll", (event: Event) => onScroll(event))
      setView(listView)
    } else if (size && size.width > 0 && size.height > 0 && view) {
      view.update((handler) => handler.updateSize(size))
    }
  }, [size])

  useEffect(() => {
    view && view.update((handler) => handler.updateLayout(layout))
  }, [layout])

  useEffect(() => {
    view && view.update((handler) => handler.updateItems(items))
  }, [items])

  return <div ref={ref} className={className} style={style}></div>
}
